import { useTranslation } from 'react-i18next';
import { useToast } from 'src/components/ui/use-toast';
import { useMutation } from '@tanstack/react-query';
import { profileClient } from 'src/lib/services/api/profile-api';

export const useSaveRequestPreferencesMutation = () => {
  const { t } = useTranslation();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (args: Parameters<typeof profileClient.savePreferences>) =>
      profileClient.savePreferences(...args),
    onSuccess: () =>
      toast({
        className: 'tw-text-base',
        description: t('Request preferences saved successfuly!'),
      }),
    onError: (err: any) =>
      toast({
        variant: 'destructive',
        className: 'tw-text-base',
        description: err?.message || t('Oops! Something went wrong. Please check in later.'),
      }),
  });
};
